var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpcoming(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4157_51222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 10L12 13L9 16",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 1V2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 1V2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 7H19",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_4157_51222",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 3.79086 1.79086 2 4 2H16C18.2091 2 20 3.79086 20 6V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V6Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4 3.5H16V0.5H4V3.5ZM18.5 6V16H21.5V6H18.5ZM16 18.5H4V21.5H16V18.5ZM1.5 16V6H-1.5V16H1.5ZM4 18.5C2.61929 18.5 1.5 17.3807 1.5 16H-1.5C-1.5 19.0376 0.962434 21.5 4 21.5V18.5ZM18.5 16C18.5 17.3807 17.3807 18.5 16 18.5V21.5C19.0376 21.5 21.5 19.0376 21.5 16H18.5ZM16 3.5C17.3807 3.5 18.5 4.61929 18.5 6H21.5C21.5 2.96243 19.0376 0.5 16 0.5V3.5ZM4 0.5C0.962434 0.5 -1.5 2.96243 -1.5 6H1.5C1.5 4.61929 2.61929 3.5 4 3.5V0.5Z",
    fill: "#197C85",
    mask: "url(#path-5-inside-1_4157_51222)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4157_51222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcoming);
export default __webpack_public_path__ + "static/media/upcoming.1a865e9316db76eac3ec70d74013c4cb.svg";
export { ForwardRef as ReactComponent };